export default __webpack_public_path__ + "static/media/G0570.34I-28261_-24276_0.1720794540000.4eada48e.jpg";